var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell24 = function SvgBell24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.19 2.606a7.707 7.707 0 0 0-4.379 0 6.589 6.589 0 0 0-4.717 6.317v2.772c0 .482-.095.959-.28 1.404l-.18.433c-.24.573-.336 1.236-.183 1.87.16.662.59 1.255 1.302 1.58.556.255 1.288.5 2.247.685V18a4 4 0 0 0 8 0v-.333c1.285-.248 2.161-.602 2.755-.945 1.129-.652 1.138-1.93.796-2.75l-.081-.196a7.32 7.32 0 0 1-.563-2.815V8.923a6.589 6.589 0 0 0-4.717-6.317ZM11.97 18H14a2 2 0 0 1-4 0h1.969Zm.06-2c3.427-.004 5.042-.618 5.718-1.006a.47.47 0 0 0-.043-.253l-.081-.196a9.318 9.318 0 0 1-.717-3.584V8.923a4.589 4.589 0 0 0-3.285-4.4 5.707 5.707 0 0 0-3.243 0 4.589 4.589 0 0 0-3.285 4.4v2.772a5.65 5.65 0 0 1-.434 2.173l-.18.433c-.11.263-.12.49-.085.63.027.113.078.182.19.233.822.376 2.43.833 5.386.836h.06Z",
    fill: "currentColor"
  })));
};
export default SvgBell24;